import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Rise = forwardRef<SVGSVGElement | null, IconFilledProps>(function Rise({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 19.0711C22.9763 15.1658 22.9763 8.83417 19.0711 4.92893C15.1658 1.02369 8.83417 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711ZM18.0104 18.0104C21.3299 14.691 21.3299 9.30905 18.0104 5.98959C14.691 2.67014 9.30905 2.67014 5.98959 5.98959C2.67014 9.30905 2.67014 14.691 5.98959 18.0104C9.30905 21.3299 14.691 21.3299 18.0104 18.0104Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M17.715 13.6246C17.9015 13.8282 17.8878 14.1444 17.6843 14.331L17.3159 14.6688C17.1123 14.8555 16.796 14.8418 16.6094 14.6382L12 9.60938L7.39065 14.6382C7.20404 14.8418 6.8877 14.8555 6.68414 14.6688L6.31572 14.331C6.11221 14.1444 6.09848 13.8282 6.28505 13.6246L12 7.38965L17.715 13.6246Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.92833 4.92833C8.8335 1.02316 15.1657 1.02331 19.0709 4.92833C22.9762 8.83358 22.9762 15.1657 19.0709 19.0709C15.1657 22.9762 8.83358 22.9762 4.92833 19.0709C1.02331 15.1657 1.02316 8.8335 4.92833 4.92833ZM6.28478 13.6246C6.09834 13.8282 6.11257 14.1441 6.31603 14.3307L6.68419 14.6686C6.88766 14.8551 7.20362 14.8416 7.39025 14.6383L11.9996 9.609L16.609 14.6383C16.7956 14.8418 17.1125 14.8552 17.316 14.6686L17.6842 14.3307C17.8876 14.1441 17.901 13.8281 17.7145 13.6246L11.9996 7.38927L6.28478 13.6246Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'rise-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Rise;
